<template>
  <div id="login">
    <el-row>
      <el-col class="left" :span="14"></el-col>
      <el-col class="right" :span="10">
        <div class="content">
          <img class="title" src="../../assets/images/loginTitle.png" />
          <el-form ref="ruleForm" :model="form" :rules="rules">
            <el-form-item prop="account">
              <el-input
                v-model="form.account"
                placeholder="请输入登录名"
                prefix-icon="el-icon-user"
              ></el-input>
            </el-form-item>
            <el-form-item prop="secret">
              <el-input
                v-model="form.secret"
                show-password
                placeholder="请输入登录密码"
                prefix-icon="el-icon-lock"
              ></el-input>
            </el-form-item>
            <el-form-item prop="verificationCode">
              <el-row>
                <el-col :span="16">
                  <el-input
                    v-model="form.verificationCode"
                    placeholder="请输入验证码"
                    :maxlength="4"
                    prefix-icon="el-icon-key"
                  ></el-input>
                </el-col>
                <el-col :span="6" :offset="2">
                  <gVerify @emitAuthCode="upDateAuthCode" />
                </el-col>
              </el-row>
            </el-form-item>
          </el-form>
          <el-button
            type="primary"
            :loading="loading"
            @click="handlerSubmit('ruleForm')"
            >登录</el-button
          >
        </div>
        <div class="bottom">
          <p>版权所有：创客天下（北京）科技发展有限公司</p>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { storage } from "@/utils/public.js";
import GVerify from "./component/gVerify";
export default {
  name: "login",
  created() {
    storage.clearOneSession("token");
  },
  data() {
    return {
      loading: false,
      authCode: "",
      form: {
        pageId: "",
        account: "",
        secret: "",
        verificationCode: ""
      },
      rules: {
        account: [
          {
            required: true,
            message: "登录名不能为空",
            trigger: ["blur", "change"]
          },
          {
            validator: (rule, value, callback) => {
              if (!/\w{5,20}/.test(value)) {
                return callback(new Error("登录名格式不正确"));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        secret: [
          {
            required: true,
            message: "登录密码不能为空",
            trigger: ["blur", "change"]
          },
          {
            validator: (rule, value, callback) => {
              if (!/\w{6,18}/.test(value)) {
                return callback(new Error("登录密码格式不正确"));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        verificationCode: [
          {
            required: true,
            message: "验证码不能为空",
            trigger: ["blur", "change"]
          },
          {
            validator: (rule, value, callback) => {
              if (value.toLowerCase() === this.authCode.toLowerCase()) {
                callback();
              } else {
                callback(new Error("验证码输入有误"));
              }
            },
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    //更新验证码
    upDateAuthCode(data) {
      this.authCode = data.verificationCode;
      this.form.pageId = data.pageId;
    },
    handlerSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true;
          this.loadCommit();
        }
      });
    },
    loadCommit() {
      this.requestApi("login", "commit", this.form, res => {
        this.loading = false;
        if (res.code === 0) {
          storage.setSession("token", res.token);
          this.setDate();
          this.redirectByPath("/admin");
        } else {
          this.$message.error(res.message);
        }
      });
    },
    setDate() {
      const d = new Date(),
        time = `${d.getFullYear()}年${d.getMonth() +
          1}月${d.getDate()}日 ${d.getHours()}时${d.getMinutes()}分`;
      storage.setSession("loginDate", time);
    }
  },
  components: {
    GVerify
  }
};
</script>

<style lang="less">
#login {
  background: #fff;

  .left {
    height: 100vh;
    background: url("../../assets/images/loginbj.jpg") center center;
    background-size: cover;
  }
  .right {
    height: 100vh;
    .content {
      height: 65vh;
      margin-top: 25vh;
      .title {
        height: 5vh;
        display: block;
        margin: 0 auto 10vh;
      }
      .el-form {
        width: 60%;
        margin: 0 auto;
        .el-form-item {
          margin-bottom: 40px;
        }
        .el-input__inner {
          border: none;
          border-bottom: 1px solid #bfbfbf;
          border-radius: 0;
        }
      }
      .el-button {
        display: block;
        width: 60%;
        height: 5vh;
        margin: 35px auto 0;
        background: linear-gradient(to right, #4979bd, #7da7ef);
      }
    }
    .bottom {
      height: 10vh;
      line-height: 10vh;
      text-align: center;
      font-size: 16px;
      color: 666666;
    }
  }
}
</style>
